module.exports = __webpack_public_path__ + "img/dlh.4449a3a0.jpg";